import { render } from "./BulkMetadataSelection.vue?vue&type=template&id=2b0c0aea&scoped=true"
import script from "./BulkMetadataSelection.vue?vue&type=script&lang=js"
export * from "./BulkMetadataSelection.vue?vue&type=script&lang=js"

import "./BulkMetadataSelection.vue?vue&type=style&index=0&id=2b0c0aea&lang=scss&scoped=true"

import exportComponent from "/Users/klaus/Projects/sfdc-happy-soup/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0c0aea"]])

export default __exports__